(function () {

    'use strict';

    angular.module('asys')
        .component('asysBlockAngebotFortsetzenLink', {
            templateUrl: 'bloecke/angebotfortsetzen/blockAngebotFortsetzenLink.html',
            controller: BlockAngebotFortsetzenLinkController,
            controllerAs: 'angebotFortsetzenVm'
        });

    BlockAngebotFortsetzenLinkController.$inject = [
        '$modal',
        '$element',
        '$timeout',
        'lodash',
        'AppConfig',
        'AngebotModel',
        'BasisAngebotService',
        'LoadingIndicatorService',
        'IntegrationService',
        'AngebotUtilsService'
    ];
    function BlockAngebotFortsetzenLinkController($modal, $element, $timeout, _, AppConfig, AngebotModel, BasisAngebotService, LoadingIndicatorService, IntegrationService, AngebotUtilsService) {
        var vm = this,
            angebotModel;

        vm.$onInit = onInit;

        vm.onBtnSpaeterFortsetzen = onBtnSpaeterFortsetzen;
        vm.isAnzeigeErlaubt = isAnzeigeErlaubt;

        function activate() {
            angebotModel = AngebotModel.get();

            var subtyp = IntegrationService.getIntegrationParams().subtyp;

            if (subtyp && AppConfig.APP.urls.produkt[subtyp || 'other']) {
                vm.homepageProduktLink = AppConfig.APP.urls.homepage + '/' + AppConfig.APP.urls.produkt[subtyp || 'other'];
            } else {
                vm.homepageProduktLink = AppConfig.APP.urls.homepage + '/' + AppConfig.APP.urls.produkt;
            }

            vm.kundenportalStartseiteLink = AppConfig.APP.urls.kundenportalStartseite;
        }

        function onInit() {
            activate();
        }

        function onBtnSpaeterFortsetzen() {
            BasisAngebotService.mapFormToServiceData(angebotModel.formData, angebotModel.angebot, angebotModel.angebotInitial, true);

            if (BasisAngebotService.hatAenderungen(angebotModel.angebot, angebotModel.angebotLetzteSpeicherung)) {
                LoadingIndicatorService.addInProgress();
                BasisAngebotService.speichere(angebotModel, {
                    globalErrorsIgnore: {
                        errors: true,
                        nachrichten: true
                    },
                    httpErrorsIgnore: true
                }).then(function (data) {
                    if (data.angebot) {
                        angebotModel.angebot = angular.merge({}, data.angebot);
                    }

                    openModalSpaeterFortsetzen();
                }).catch(function (error) {
                    AngebotUtilsService.handleCloseAndNavigation(angebotModel);
                }).finally(function () {
                    LoadingIndicatorService.removeInProgress();
                });
            } else {
                openModalSpaeterFortsetzen();
            }
        }

        function openModalSpaeterFortsetzen() {
            var modalAngebotFortsetzen = $modal.open({
                templateUrl: 'modal/modalAngebotFortsetzen.html',
                windowClass: 'medium',
                controller: 'ModalAngebotFortsetzenController',
                controllerAs: 'modalVm',
                resolve: { /* @ngInject */
                    options: [function () {
                        return {};
                    }]
                }
            });

            modalAngebotFortsetzen.result.then(function (action) {
                focusElementAfterCloseModal();

                $timeout(function () {
                    if (_.includes(['copyUrl', 'email'], action)) {
                        AngebotUtilsService.handleCloseAndNavigation(angebotModel);
                        return;
                    }
                }, (action === 'email' ? 2000 : 0));
            }).catch(function (error) {
                focusElementAfterCloseModal();
            });
        }

        function focusElementAfterCloseModal() {
            if (!$element || !$element[0] || !$element[0].querySelector('[tabindex]')) {
                return;
            }

            $element[0].querySelector('[tabindex]').focus();
        }

        function isAnzeigeErlaubt() {
            return BasisAngebotService.isAngebotAenderbar(angebotModel.angebot, 'ANTRAG');
        }
    }

})();
